import { useState } from 'react'

function useDialog(showByDefault = false) {
  const [isShowingDialog, setIsShowingDialog] = useState<boolean>(showByDefault)
  const showDialog = () => setIsShowingDialog(true)
  const hideDialog = () => setIsShowingDialog(false)
  const toggleDialog = () => setIsShowingDialog(!isShowingDialog)

  return { isShowingDialog, showDialog, hideDialog, toggleDialog }
}

export default useDialog
